import {
	IMethodInvokeAction,
	MethodInvokeAction,
	MethodInvokeActionFactoryFromJS
} from './IMethodInvokeAction';
import {
	IShowMessageAction,
	ShowMessageAction,
	ShowMessageActionFactoryFromJS
} from './IShowMessageAction';
import {
	IValidationFailureAction,
	ValidationFailureAction,
	ValidationFailureActionFactoryFromJS
} from './IValidationFailureAction';
import {
	IValueAssignActionWithEntry,
	ValueAssignActionWithEntry,
	ValueAssignActionWithEntryFactoryFromJS
} from './IValueAssignActionWithEntry';
import {
	IValueAssignActionWithFormula,
	ValueAssignActionWithFormula,
	ValueAssignActionWithFormulaFactoryFromJS
} from './IValueAssignActionWithFormula';
import {
	IValueAssignActionWithSelection,
	ValueAssignActionWithSelection,
	ValueAssignActionWithSelectionFactoryFromJS
} from './IValueAssignActionWithSelection';

export type IAction =
	| IMethodInvokeAction
	| IShowMessageAction
	| IValidationFailureAction
	| IValueAssignActionWithFormula
	| IValueAssignActionWithEntry
	| IValueAssignActionWithSelection;

export type Action =
	| MethodInvokeAction
	| ShowMessageAction
	| ValidationFailureAction
	| ValueAssignActionWithFormula
	| ValueAssignActionWithEntry
	| ValueAssignActionWithSelection;

export const ActionFactoryFromJS = (data: IAction) => {
	switch (data.typeName) {
		case 'ShowMessageAction':
			return ShowMessageActionFactoryFromJS(data);
		case 'ValidationFailureAction':
			return ValidationFailureActionFactoryFromJS(data);
		case 'ValueAssignActionWithEntry':
			return ValueAssignActionWithEntryFactoryFromJS(data);
		case 'ValueAssignActionWithFormula':
			return ValueAssignActionWithFormulaFactoryFromJS(data);
		case 'ValueAssignActionWithSelection':
			return ValueAssignActionWithSelectionFactoryFromJS(data);
		case 'MethodInvokeAction':
			return MethodInvokeActionFactoryFromJS(data);
	}
};
